import * as ROUTES from '../../constants/routes';
import { useNavigate } from 'react-router-dom';
import Container from '../../components/container/Container';
import useAuth from '../../hooks/useAuth';

const ProfilePage = () => {
  const navigate = useNavigate();

  const { user } = useAuth();

  return (
    <Container>
      <main className="px-4 sm:px-6 lg:flex-auto lg:px-0">
        <div className="mx-auto max-w-2xl space-y-8 sm:space-y-16 lg:mx-0 lg:max-w-none">
          <div>
            <h2 className="text-xl font-semibold leading-7 text-gray-900">
              Profile
            </h2>
            <dl className="mt-6 space-y-6 divide-y divide-gray-100 border-t border-gray-200 text-sm leading-6">
              <div className="pt-6 sm:flex">
                <dt className="font-medium text-gray-900 sm:w-64 sm:flex-none sm:pr-6">
                  Full name
                </dt>
                <dd className="mt-1 flex justify-between gap-x-6 sm:mt-0 sm:flex-auto">
                  <div className="text-gray-900">
                    {user?.firstName} {user?.lastName}
                  </div>
                </dd>
              </div>
              <div className="pt-6 sm:flex">
                <dt className="font-medium text-gray-900 sm:w-64 sm:flex-none sm:pr-6">
                  Email address
                </dt>
                <dd className="mt-1 flex justify-between gap-x-6 sm:mt-0 sm:flex-auto">
                  <div className="text-gray-900">{user?.email}</div>
                </dd>
              </div>
            </dl>
          </div>
          <div className=" flex items-center gap-x-6">
            <button
              type="button"
              onClick={() => {
                navigate(ROUTES.EDIT_PROFILE);
              }}
              className="rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
            >
              Edit Profile
            </button>
          </div>

          <div className="pb-6">
            <h2 className="text-xl font-semibold leading-7 text-gray-900">
              Password Management
            </h2>

            <dl className="mt-6 space-y-6 divide-y divide-gray-100 border-t border-gray-200 text-sm leading-6">
              <div className="pt-6 sm:flex">
                <dt className="font-medium text-gray-900 sm:w-64 sm:flex-none sm:pr-6">
                  Password
                </dt>
                <dd className="mt-1 flex justify-between gap-x-6 sm:mt-0 sm:flex-auto">
                  <div className="text-gray-900">********</div>
                  <button
                    type="button"
                    onClick={() => {
                      navigate(ROUTES.CHANGE_PASSWORD);
                    }}
                    className="font-semibold text-indigo-600 hover:text-indigo-500"
                  >
                    Edit
                  </button>
                </dd>
              </div>
            </dl>
          </div>
        </div>
      </main>
    </Container>
  );
};

export default ProfilePage;
